import { ReactElement } from 'react';
import { join } from 'light-component';
import { Box } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import type { TextAreaProps } from './types';

export function TextAreaViewMode(props: TextAreaProps): ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter title={props.title} keyword={props.keyword} className={styles.title} />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Base.Input.TextArea
          value={props.value}
          readOnly={true}
        />
      </Box>
    </Box>
  );
}
